import React, { useState } from "react";
import Modal from "../../components/common/Modal";

const initialData = [
  {
    id: 787,
    name: "STUDENTS SESSION",
    policyFor: "Student",
    inTimeFrom: "07:00",
    inTimeTo: "09:00",
    lateTimeFrom: "09:01",
    lateTimeTo: "10:00",
    outTimeFrom: "12:30",
    outTimeTo: "13:20",
    inSms:
      "Attendance alert: Dear Parent, your ward $studentname attendance status: Present, Time: $time. Thank you $orgname",
    outSms:
      "Attendance alert: Dear Parent, your ward $studentname attendance status: Logged Out, Time: $time. Thank you $orgname",
    lateSms:
      "Attendance alert: Dear Parent, your ward $studentname attendance status: Late Present, Time: $time. Thank you $orgname",
  },
  {
    id: 788,
    name: "STAFF SESSION",
    policyFor: "Staff",
    inTimeFrom: "08:00",
    inTimeTo: "10:31",
    lateTimeFrom: "10:31",
    lateTimeTo: "10:35",
    outTimeFrom: "12:50",
    outTimeTo: "14:00",
    inSms: "",
    outSms: "",
    lateSms: "",
  },
];

const emptyForm = {
  id: null,
  name: "",
  policyFor: "Student",
  inTimeFrom: "",
  inTimeTo: "",
  lateTimeFrom: "",
  lateTimeTo: "",
  outTimeFrom: "",
  outTimeTo: "",
  inSms: "",
  outSms: "",
  lateSms: "",
};

const TimePolicyMaster = () => {
  const [tableData, setTableData] = useState(initialData);
  const [search, setSearch] = useState("");

  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteId, setDeleteId] = useState(null);

  const [formData, setFormData] = useState(emptyForm);

  const filteredData = tableData.filter(
    (item) =>
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.policyFor.toLowerCase().includes(search.toLowerCase())
  );

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAdd = () => {
    setFormData(emptyForm);
    setShowFormModal(true);
  };

  const handleEdit = (row) => {
    setFormData(row);
    setShowFormModal(true);
  };

  const handleSave = (e) => {
    e.preventDefault();

    if (formData.id) {
      setTableData((prev) =>
        prev.map((item) =>
          item.id === formData.id ? formData : item
        )
      );
    } else {
      setTableData((prev) => [
        ...prev,
        {
          ...formData,
          id: Date.now(),
        },
      ]);
    }

    setShowFormModal(false);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDelete = () => {
    setTableData((prev) =>
      prev.filter((item) => item.id !== deleteId)
    );

    setShowDeleteModal(false);
  };

  return (
    <>
      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">RFID Time Policy List</h5>

          <button
            className="btn btn-primary"
            onClick={handleAdd}
          >
            <i className="bi bi-plus-circle me-2"></i>
            Add Time Policy
          </button>
        </div>

        <div className="card-body">
          {/* <div className="row mb-3">
            <div className="col-md-4 ms-auto">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={search}
                onChange={(e) =>
                  setSearch(e.target.value)
                }
              />
            </div>
          </div> */}

          <div className="table-responsive border">
            <table className="table align-middle">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>ID</th>
                  <th>Policy For</th>
                  <th>In Time</th>
                  <th>Late Time</th>
                  <th>Out Time</th>
                  <th width="150">Actions</th>
                </tr>
              </thead>

              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((row, index) => (
                    <tr key={row.id}>
                      <td>{index + 1}</td>
                      <td>{row.name}</td>
                      <td>{row.id}</td>
                      <td>{row.policyFor}</td>

                      <td>
                        {row.inTimeFrom} - {row.inTimeTo}
                      </td>

                      <td>
                        {row.lateTimeFrom} - {row.lateTimeTo}
                      </td>

                      <td>
                        {row.outTimeFrom} - {row.outTimeTo}
                      </td>

                      <td>
                        <button
                          className="btn btn-success btn-sm me-2"
                          onClick={() => handleEdit(row)}
                        >
                          <i className="bi bi-pencil"></i>
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() =>
                            handleDeleteClick(row.id)
                          }
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="8"
                      className="text-center"
                    >
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add/Edit Modal */}

      <Modal
        show={showFormModal}
        onClose={() => setShowFormModal(false)}
        title={
          formData.id
            ? "Edit Time Policy"
            : "Add Time Policy"
        }
        size="lg"
      >
        <form onSubmit={handleSave}>
          <div className="container-fluid">

            <div className="mb-3">
              <label className="form-label">
                Time Policy Name
              </label>

              <input
                type="text"
                className="form-control"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">
                Time Policy For
              </label>

              <select
                className="form-select"
                name="policyFor"
                value={formData.policyFor}
                onChange={handleChange}
              >
                <option value="Student">
                  Student
                </option>

                <option value="Staff">
                  Staff
                </option>
              </select>
            </div>

            <hr />

            <h6 className="fw-bold">
              Select IN Time
            </h6>

            <div className="row mb-3">
              <div className="col-md-6">
                <input
                  type="time"
                  className="form-control"
                  name="inTimeFrom"
                  value={formData.inTimeFrom}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <input
                  type="time"
                  className="form-control"
                  name="inTimeTo"
                  value={formData.inTimeTo}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">
                IN Time SMS Description
              </label>

              <textarea
                rows="4"
                className="form-control"
                name="inSms"
                value={formData.inSms}
                onChange={handleChange}
              />
            </div>

            <hr />

            <h6 className="fw-bold">
              Select OUT Time
            </h6>

            <div className="row mb-3">
              <div className="col-md-6">
                <input
                  type="time"
                  className="form-control"
                  name="outTimeFrom"
                  value={formData.outTimeFrom}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <input
                  type="time"
                  className="form-control"
                  name="outTimeTo"
                  value={formData.outTimeTo}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">
                OUT Time SMS Description
              </label>

              <textarea
                rows="4"
                className="form-control"
                name="outSms"
                value={formData.outSms}
                onChange={handleChange}
              />
            </div>

            <hr />

            <h6 className="fw-bold">
              Select Late Time
            </h6>

            <div className="row mb-3">
              <div className="col-md-6">
                <input
                  type="time"
                  className="form-control"
                  name="lateTimeFrom"
                  value={formData.lateTimeFrom}
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <input
                  type="time"
                  className="form-control"
                  name="lateTimeTo"
                  value={formData.lateTimeTo}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label">
                Late Time SMS Description
              </label>

              <textarea
                rows="4"
                className="form-control"
                name="lateSms"
                value={formData.lateSms}
                onChange={handleChange}
              />
            </div>

            <div className="text-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() =>
                  setShowFormModal(false)
                }
              >
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-success"
              >
                {formData.id
                  ? "Update"
                  : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Modal>

      {/* Delete Modal */}

      <Modal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="Delete Time Policy"
        size="sm"
      >
        <div className="text-center py-3">
          <i className="bi bi-trash text-danger fs-1"></i>

          <h5 className="mt-3">
            Are you sure?
          </h5>

          <p>
            Do you want to delete this Time Policy?
          </p>

          <button
            className="btn btn-secondary me-2"
            onClick={() =>
              setShowDeleteModal(false)
            }
          >
            Cancel
          </button>

          <button
            className="btn btn-danger"
            onClick={handleDelete}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default TimePolicyMaster;